module.exports = __webpack_public_path__ + "media/trucks/small_van-d030c76b.svg";